import { identity } from 'fp-ts/lib/function';
import type { ChangeEvent } from 'react';
import { trimValue, trimValueLeft } from 'utils/formValidation/trimValue';

export type FormikAutoTrim = 'all' | 'left';

export const getTrimFunction = (
  trim: FormikAutoTrim | undefined,
): ((
  onChange: (e: ChangeEvent<HTMLInputElement>) => void,
) => (e: ChangeEvent<HTMLInputElement>) => void) => {
  switch (trim) {
    case 'all':
      return trimValue;
    case 'left':
      return trimValueLeft;
    default:
      return identity;
  }
};
